import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import i18n from '@/i18n';

const TOKEN_KEY = 'activeid_token';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add auth token
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Tell the backend which language to localize responses in (Stage 2
    // server-side localization reads this; harmless until then).
    if (i18n.language) {
      config.headers['Accept-Language'] = i18n.language;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Don't redirect if we're on the login page or doing MFA validation
      const isAuthRoute = window.location.pathname.includes('/login') ||
                          error.config?.url?.includes('/api/auth/');

      if (!isAuthRoute) {
        // Unauthorized - clear token and redirect to login
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem('activeid_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
